import IconAlert from "../../components/elements/IconAlert";

export const columns = (navigate, setModalRol,openModalAdd) => [
    {
        id: "name",
        name: "Name",
        minWidth: "240px",
        cell: (row) => (
            <div className="flex items-center gap-3">
                <div className="flex flex-col">
                    <span className="text-sm font-semibold text-cs-dark leading-tight">
                        {row.name}
                    </span>
                    {row.slug && (
                        <span className="text-[9px] text-cs-muted uppercase tracking-wide">
                            {row.slug}
                        </span>
                    )}
                </div>
            </div>
        ),
    },
    {
        id: "description",
        name: "Description",
        minWidth: "260px",
        cell: (row) => (
            <div className="flex flex-col gap-0.5">
                <span className="text-[10px] text-cs-muted line-clamp-2">
                    {row.description || "No description provided for this role."}
                </span>
            </div>
        ),
    },
    {
        id: "models",
        name: "Models & permissions",
        minWidth: "220px",
        cell: (row) => {
            const totalModels = row.models_total || 0;
            
            return (
                <div className="flex items-center gap-2 text-[10px]">
                    {/* Badge resumen */}
                    <div className="flex items-center gap-1 px-2 py-1 rounded-full bg-cs-primary-soft text-cs-primary-dark border border-cs-border">
                        <span className="material-symbols-outlined text-[14px]">
                            view_list
                        </span>
                        <span className="font-medium">
                            {totalModels} Models
                        </span>
                    </div>

                    {/* Botón para abrir modal */}
                    <button
                        type="button"
                        onClick={() =>
                            setModalRol({
                                show: true,
                                rol: row,
                                title: row.name,
                            })
                        }
                        className="
                            inline-flex items-center gap-1.5
                            px-2 py-1 rounded-lg
                            bg-cs-bg-alt
                            text-cs-muted
                            hover:bg-cs-primary
                            hover:text-white
                            border border-cs-border
                            hover:border-cs-primary-hover
                            text-[9px]
                            transition-all
                        "
                        title="Show models & permissions"
                    >
                        <span className="material-symbols-outlined text-[14px]">
                            shield_person
                        </span>
                        <span>View details</span>
                    </button>
                </div>
            );
        },
    },
    {
        id: "actions",
        name: "",
        right: true,
        minWidth: "90px",
        cell: (row) => {
            const canDelete = !!row.can?.delete;

            return (
                <div className="flex items-center justify-end gap-2">
                    {/* Edit */}
                    <button
                        type="button"
                        onClick={() => openModalAdd(row)}
                        className="
                            p-1.5 rounded-lg
                            text-cs-muted
                            hover:bg-cs-primary-soft
                            hover:text-cs-primary
                            transition-colors
                        "
                        title="Edit"
                    >
                        <span className="material-symbols-outlined text-[18px]">
                            Edit
                        </span>
                    </button>

                    {/* Ejemplo: si después quieres delete, ya tienes canDelete listo */}
                    {canDelete && (
                        <button
                            type="button"
                            className="
                                p-1.5 rounded-lg
                                text-cs-danger
                                hover:bg-cs-danger/5
                                transition-colors
                            "
                            title="Delete"
                        >
                            <span className="material-symbols-outlined text-[18px]">
                                delete
                            </span>
                        </button>
                    )}
                </div>
            );
        },
    },
];
